/* eslint-disable */
export default {
  logging: 'Iniciando sesión...',
  logCall: 'Registrar llamada',
  editLog: 'Editar registro',
  select: 'Sel. registro',
  OnHold: 'En espera',
  Ringing: 'Llamando',
  CallConnected: 'Llamada conectada',
  unknownUser: 'Usuario desconocido',
  unknownNumber: 'Anónimo',
  unavailable: 'No disponible',
  viewDetails: 'Ver detalles',
  conferenceCall: 'Llamada de conferencia',
  callerId: 'ID de llamadas',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
